module.exports = __webpack_public_path__ + "img/jsfny2.1b897b5a.png";